export const daysRestriction = {
  label:
    "This participant has had an active GPRA record within the past 30 days, we advise 30-day restrictions on creating new GPRA records, but you may choose to acknowledge this continue anyway by checking the box below.",
  type: "Warning",
}
export const noGpraProgram = {
  label:
    "No GPRA enabled Programs are assigned to the participant. Please direct to Manage Service ",
}
